import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 15h15","key":"svg-0"}],["path",{"d":"M21 19h-15","key":"svg-1"}],["path",{"d":"M15 11h6","key":"svg-2"}],["path",{"d":"M21 7h-6","key":"svg-3"}],["path",{"d":"M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2","key":"svg-4"}],["path",{"d":"M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2","key":"svg-5"}]]

const IconBlockquote = createReactComponent('outline', 'blockquote', 'Blockquote', __iconNode);

export default IconBlockquote;